import { render } from "./pdv-purchase.vue?vue&type=template&id=73e9b1bc&scoped=true"
import script from "./pdv-purchase.vue?vue&type=script&lang=js"
export * from "./pdv-purchase.vue?vue&type=script&lang=js"

import "./pdv-purchase.vue?vue&type=style&index=0&id=73e9b1bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e9b1bc"]])

export default __exports__